<template src='./project-information.html'></template>

<script>
import ContextPage from '@/components/misc/context-page/ContextPage.vue'
import ProjectDetails from './details/ProjectDetails.vue'
import ProjectPhases from './phases/ProjectPhases.vue'
import ProjectDocuments from './documents/Documents.vue'
import ProjectOptions from './options/ProjectOptions.vue'
import Vue from 'vue'
import { EventBus } from '@/router/bus'
import { hasAdminClaim } from '@/router/auth.js'

export default {
  components: {
    ContextPage,
    'project-details': ProjectDetails,
    'project-phases': ProjectPhases,
    'project-documents': ProjectDocuments,
    'project-options': ProjectOptions
  },
  data () {
    return {
      projectCode: this.$route.params.projectCode,
      projectPhaseId: this.$route.params.projectPhaseId,
      selectedPhaseId: this.$route.params.projectPhaseId,
      selectedPhase: {},
      selectedPhasePhase: '',
      selectedPhaseTab: 'forms',
      pageLoader: false,
      tab: null,
      subTab: null,
      project: {},
      projectPhase: 0,
      projectPhases: [],
      phases: [
        { Id: 0, Name: 'Idea' },
        { Id: 1, Name: 'ProjectIdentification' },
        { Id: 2, Name: 'Preparedness' },
        { Id: 3, Name: 'Important' },
        { Id: 4, Name: 'Plan' },
        { Id: 5, Name: 'Reporting' },
        { Id: 11, Name: 'Correction' },
        { Id: 12, Name: 'CorrectionReporting' },
        { Id: 13, Name: 'Rationalization' },
        { Id: 7, Name: 'Conclusion' },
        { Id: 8, Name: 'Effects' }
      ],
      phaseStatus: {
        POSTPONED: 8,
        STOPPED: 9
      },
      projectStatus: {
        PENDING: 0,
        FINISHED: 1,
        ARCHIVED: 2
      },
      projectType: {
        Implementation: 1,
        PreImplementation: 2,
        NewImplementation: 3
      },
      statuses: [
        {
          color: 'pending',
          text: this.$t('projects.statuses.0')
        },
        {
          color: 'success',
          text: this.$t('projects.statuses.1')
        }
      ],
      isMeiCommentPopulated: false,
      isMfinCommentPopulated: true
    }
  },
  mounted () {
    const routeTab = this.$route.path.split('/')[3]
    if (this.tab !== routeTab) {
      this.tab = routeTab
    }

    this.setupPage()

    EventBus.$on('auto-phase', (phases, currentPhase, currentStatus) => {
      this.projectPhase = currentPhase
      this.projectPhases = this.managePhases(phases)
      this.project.status = currentStatus
    })

    EventBus.$on('subTab', (subTab) => {
      if (this.tab === 'phases') {
        this.selectedPhaseTab = subTab
      }
      this.subTab = subTab
    })

    EventBus.$on('selectedPhase', (phase) => {
      this.selectedPhase = phase
      this.selectedPhasePhase = phase.phase
      this.projectPhaseId = phase.id
      const getPhaseFormId = phase.forms[0].id
      this.getIsMeiCommentPopulated(getPhaseFormId)
      this.getIsMfinCommentPopulated(getPhaseFormId)
    })

    EventBus.$on('projectLoader', (loader) => {
      this.pageLoader = loader
    })
  },
  computed: {
    helpUrl () {
      const phase = this.selectedPhasePhase && this.tab === 'phases' ? (Vue.$helpConfig.projectPhases.filter(x => x.value === this.selectedPhasePhase)[0].text ? '/' + Vue.$helpConfig.projectPhases.filter(x => x.value === this.selectedPhasePhase)[0].text : '') : ''
      const tab = this.tab ? ('/' + Vue.$helpConfig.projectTabs.filter(x => x.value === this.tab)[0].text ? '/' + Vue.$helpConfig.projectTabs.filter(x => x.value === this.tab)[0].text : '') : ''
      const subTab = this.subTab ? (Vue.$helpConfig.projectSubTabs.filter(x => x.value === this.subTab)[0].text ? '/' + Vue.$helpConfig.projectSubTabs.filter(x => x.value === this.subTab)[0].text : '') : ''
      return Vue.$helpConfig.projectDetails.replace('{tab}', tab).replace('{phase}', phase).replace('{subTab}', subTab)
    },
    canUserViewMergingTabPage () {
      return hasAdminClaim() && this.project.important && !this.project.isMerged
    },
    canUserViewListsTabPage () {
      return hasAdminClaim() && this.project.important
    },
    getSelectedFormId () {
      return this.selectedPhase.forms[0].id
    }
  },
  methods: {
    setupPage () {
      this.pageLoader = true
      this.$http.get(Vue.$apiConfig.projectPhasesGet.replace('{projectCode}', this.$route.params.projectCode), { params: { noData: true } })
        .then(
          response => {
            // this.logConsole(response)
            this.project = response.data.additionalInformation
            this.projectPhase = this.project.phase
            this.projectPhases = this.managePhases(response.data.payload)
            this.pageLoader = false
          },
          error => {
            this.formatErrorResponse(error)
            this.pageLoader = false
          }
        )
    },
    getIsMeiCommentPopulated (getPhaseFormId) {
      this.$http.get(Vue.$apiConfig.inputFormGet.replace('{projectCode}', this.$route.params.projectCode) + '/forms/' + getPhaseFormId)
        .then(
          response => {
            const formInputJson = JSON.parse(response.body.payload.inputJson)
            // Idea additional information for showing buttons
            if (this.selectedPhase.phase === 0 && this.project.foreignFunds) {
              this.isMeiCommentPopulated = formInputJson['preliminary evaluation'].length > 0
            }
          },
          error => {
            this.formatErrorResponse(error)
            this.pageLoader = false
          }
        )
    },
    getIsMfinCommentPopulated (getPhaseFormId) {
      this.$http.get(Vue.$apiConfig.inputFormGet.replace('{projectCode}', this.$route.params.projectCode) + '/forms/' + getPhaseFormId)
        .then(
          response => {
            const formInputJson = JSON.parse(response.body.payload.inputJson)
            // Idea additional information for showing buttons
            if (this.selectedPhase.phase === 0 && this.selectedPhase.status === 4) {
              this.isMfinCommentPopulated = formInputJson['preliminary opinion'].replace('/(\r\n?|\n)/gm', '').trim().length > 0
            }
            if (this.selectedPhase.phase === 1 && this.selectedPhase.status === 4) {
              this.isMfinCommentPopulated = formInputJson['admin financial opinion'].replace('/(\r\n?|\n)/gm', '').trim().length > 0
            }
            if (this.selectedPhase.phase === 2 && this.selectedPhase.status === 4) {
              this.isMfinCommentPopulated = formInputJson['admin financial opinion'].replace('/(\r\n?|\n)/gm', '').trim().length > 0
            }
          },
          error => {
            this.formatErrorResponse(error)
            this.pageLoader = false
          }
        )
    },
    managePhases (phases) {
      const projectPhases = []
      for (let i = 0; i < this.phases.length; i++) {
        var phase = phases.filter(x => x.phase === this.phases[i].Id)
        if (phase && phase.length > 0) {
          projectPhases.push(phase[0])
        } else {
          projectPhases.push({ phase: this.phases[i].Id })
        }
      }
      return projectPhases
    },
    selectPhase (phase, disabled) {
      if (disabled) return
      this.selectedPhase = phase
      this.selectedPhasePhase = phase.phase
      this.$route.params.projectPhaseId = phase.id
      this.tab = 'phases'
    },
    tabChanged (tab) {
      this.subTab = ''
      if (tab === 'options') {
        this.subTab = 'settings'
        this.$router.push('/projects/' + this.projectCode + `/${tab}` + `/${this.subTab}`)
      } else if (tab === 'phases') {
        this.subTab = 'forms'
        this.$router.push('/projects/' + this.projectCode + `/${tab}` + `/${this.project.projectPhaseId}` + '/' + `${this.selectedPhaseTab}`)
      } else {
        this.$router.push('/projects/' + this.projectCode + `/${tab}`)
      }
      EventBus.$emit('reload-crumbs')
    },
    formatStepperLabel (value) {
      return value.split(' ').join('\n')
    }
  }
}
</script>
<style lang="scss">
.v-chip {
  font-weight: 600 !important;
  /* font-size: 20px !important */
}
.item-container {
  font-weight: 600 !important;
  font-size: 15px !important;
}
.v-stepper {
  box-shadow: none !important;
  background-color: var(--v-background-base) !important;
}
.drop-menu-item {
  margin: 0 0 0 50px;
}
.claim-item {
  font-size: 15px;
  font-weight: 300;
  line-height: 1;
  letter-spacing: 0.02em;
  font-family: 'Source Sans Pro', sans-serif;
  margin-left: 30px;
}

.centered-label {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.list-container {
  height: 264px;
  overflow-y: auto;
  font-size: 11pt;
  border: 1px solid rgba(0, 0, 0, .12);
}
.clickable-list {
  cursor: pointer;
}
.dense-list {
  min-height: 22px !important;
}

.selected-phase {
  background-color:rgb(228, 227, 227)
}

.v-stepper__step--complete {
  cursor: pointer;
}

.v-stepper__step--complete:hover {
  background: #f5f5f5;
}

.v-stepper__step--complete .v-stepper__label > button::before {
  background-color: transparent;
}

.v-stepper__step--complete .v-stepper__label button > .v-ripple__container{
  display: none;
}

.v-alert-status {
  &.v-alert {
    padding: 0 6px 3px 6px !important;
  }
  & .v-alert__icon {
    margin-right: 12px !important;
  }
  & .v-icon::before {
    font-size: 28px;
  }
  & .v-alert__content {
    line-height: 1.4;
  }
  & .v-alert__icon {
    padding-top: 24px;
    padding-left: 6px;
  }
  & .v-alert__icon {
    padding-top: 24px;
    padding-left: 6px;
  }
  & .v-alert__content-title {
    font-size: 14px;
  }
  & .v-alert__content-text {
    font-size: 14px;
  }
}

/* Display stepper label on mobile */
@media only screen and (max-width: 959px) {
  .v-stepper:not(.v-stepper--vertical) .v-stepper__label {
    display: flex !important;
    width: 44px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

</style>
